module.exports = __webpack_public_path__ + "img/13.fe668ada.png";